
import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register the necessary Chart.js elements and plugins
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

const DevelopmentStrategiesSection = ({ percentages, labels }) => {
  // Validate inputs
  if (!percentages || !labels || percentages.length !== labels.length) {
    return <div>Invalid data passed to the component</div>;
  }

  // Data for the pie chart
  const data = {
    labels: labels,
    datasets: [
      {
        data: percentages, // Pass dynamic percentages
        backgroundColor: ['#e6c6c6', '#d09d9d', '#b45f5f', '#7e3535'],
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  // Options for the pie chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      datalabels: {
        formatter: (value) => `${value}%`, // Show percentage label
        color: '#fff', // Label color
        font: {
          weight: 'bold',
        },
        anchor: 'center',
        align: 'center',
      },
    },
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
      <div className="grid place-items-center my-4">
        <p className="services-header flex justify-center after:w-32 after:-bottom-2">
          نسبة استراتيجية التطوير من المحتوى
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          alignItems: 'center',
        }}
        className="row justify-content-between align-items-center"
      >
        <div
          style={{
         
            border: '1px solid #D9D9D9',
            borderRadius: '12px',
          }}
          className="col-md-6"
        >
          <Pie
            data={data}
            options={options}
            style={{
              margin: ' 0 auto',
              width: '250px',
              height: '250px',
            }}
            className=""
          />
        </div>
        <div
          style={{ marginBottom: '20px' }}
          className="row justify-content-between col-md-6 align-items-center"
        >
          {labels.map((label, index) => (
            <div
              key={index}
              style={{
                marginBottom: '40px',
                border: '1px solid #D9D9D9',
                borderRadius: '12px',
              }}
              className="col-md-5 position-relative"
            >
              <p
                style={{ fontWeight: 'bold' }}
                className="size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw z-10 absolute -top-5 text-white"
              >
                {percentages[index]}%
              </p>
              <p className="mt-4">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// import React from 'react';
// import { Pie } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// // Register the necessary Chart.js elements
// ChartJS.register(ArcElement, Tooltip, Legend);

// const DevelopmentStrategiesSection = () => {
//     // Data for the pie chart
//     const data = {
//         labels: [
//             'مفاهيم ومعارف',
//             'استبيانات قياس مهارات',
//             'أوراق عمل وتخطيط شخصي',
//             'أنشطة تطبيقية ومهام تعاونية',
//         ],
//         datasets: [
//             {
//                 data: [30, 15, 20, 35], // Percentage values for the pie chart
//                 backgroundColor: ['#e6c6c6', '#d09d9d', '#b45f5f', '#7e3535'],
//                 borderColor: '#fff',
//                 borderWidth: 1,
//             },
//         ],
//     };

//     // Options for the pie chart
//     const options = {
//         responsive: true,
//         plugins: {
//             legend: {
//                 position: 'top',
//             },
//         },
//     };

//     return (
//         <div style={{ textAlign: 'center', padding: '20px' }}>
//             <div className="grid place-items-center my-4">
//                 <p className="services-header flex justify-center after:w-32 after:-bottom-2">
//                     نسبة استراتيجية التطوير من المحتوى
//                 </p>
//             </div>
//             <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'center' }} className='row justify-content-between align-items-center'>
//                 <div style={{ marginBottom: '20px', height: '200px' }} className='col-md-6'>
//                     <Pie data={data} options={options} style={{
//                         border: '1px solid #D9D9D9', borderRadius: '12px',
//                         height: '100%'
//                     }} className='w-100' />
//                 </div>
//                 <div style={{ marginBottom: '20px' }} className='row justify-content-between align-items-center col-md-5'>
//                     <div style={{ marginBottom: '30px', border: '1px solid #D9D9D9', borderRadius: '12px', }} className='col-md-5 position-relative'>
//                         <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >15%</p>

//                         <p className='mt-4'>استبيانات قياس مهارات</p>
//                     </div>
//                     <div style={{ marginBottom: '30px', border: '1px solid #D9D9D9', borderRadius: '12px', }} className='col-md-5 position-relative'>
//                         <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >30%</p>
//                         <p className='mt-4'>مفاهيم ومعارف</p>
//                     </div>
//                     <div style={{ marginBottom: '30px', border: '1px solid #D9D9D9', borderRadius: '12px', }} className='col-md-5 position-relative'>
//                         <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >20%</p>
//                         <p className='mt-4'>أوراق عمل وتخطيط شخصي</p>
//                     </div>
//                     <div style={{ marginBottom: '30px', border: '1px solid #D9D9D9', borderRadius: '12px', }} className='col-md-5 position-relative'>
//                         <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >35%</p>
//                         <p className='mt-4'>أنشطة تطبيقية ومهام تعاونية</p>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };


 export default DevelopmentStrategiesSection;
